export default {
  trips: {
    trips: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      pages: 0,
      prev: null,
      next: null
    }
  },
  trip: null,
  currentPage : 1,
  filters : {
  }
}
